export default __webpack_public_path__ + "static/media/breakfast3.0fee32ea.png";